import { useCallback } from 'react';
import { integrationsApi, } from 'apis/integrations';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { sanitizeHtml } from 'utils/sanitizeHtml';
import { getTrimmedSignatureTemplate } from './helper';
/** A hook that handles updating an email. */
export const useUpdateEmail = () => {
    const dispatch = useAppDispatch();
    const updateEmail = useCallback(({ emailAddress, senderName, signatureTemplate }) => {
        var _a;
        const updates = Object.assign(Object.assign({}, (senderName && {
            sender_name: (senderName === null || senderName === void 0 ? void 0 : senderName.trim()) || null,
        })), (signatureTemplate && {
            signature_template: signatureTemplate
                ? sanitizeHtml((_a = getTrimmedSignatureTemplate(signatureTemplate)) !== null && _a !== void 0 ? _a : '', 'email')
                : null,
        }));
        const deletes = [];
        if (!senderName) {
            deletes.push('sender_name');
        }
        if (!signatureTemplate) {
            deletes.push('signature_template');
        }
        const payload = {
            emailAddress,
            patch: { updates, deletes },
        };
        return dispatch(integrationsApi.endpoints.updateEmailIntegration.initiate(payload));
    }, [dispatch]);
    return updateEmail;
};
